import { render, staticRenderFns } from "./PartyMemberManagement.vue?vue&type=template&id=d874b3d2&scoped=true"
import script from "./PartyMemberManagement.vue?vue&type=script&lang=js"
export * from "./PartyMemberManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d874b3d2",
  null
  
)

export default component.exports